import rill from "rill";

import customWorkflowsController from "./custom-workflows.controller";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import { getRoleNameById } from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";

const CustomWorkflows = (app) => {
  app.at(
    "/custom-workflows/*",
    rill().setup((app) => {
      app.get(
        "/",
        (ctx, next) => {
          const { activeUser, organizationRoles } = ctx.locals;
          const roleName = !!activeUser.organizationRoleId
            ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
            : "Owner";
          const isAdminOrOwner = roleName === "Owner" || roleName === "Admin";
          if (isAdminOrOwner) return next();

          return checkOrganizationSectionPermission(
            ctx,
            next,
            ["Custom Workflows"],
            "/coaching-portal/athletes"
          );
        },
        customWorkflowsController
      );
    })
  );
};

export default CustomWorkflows;
